__turbopack_context__.v({
  "department": "greenhouse-module-scss-module__cTn8uq__department",
  "department-heading": "greenhouse-module-scss-module__cTn8uq__department-heading",
  "form": "greenhouse-module-scss-module__cTn8uq__form",
  "job": "greenhouse-module-scss-module__cTn8uq__job",
  "job-title": "greenhouse-module-scss-module__cTn8uq__job-title",
  "nested": "greenhouse-module-scss-module__cTn8uq__nested",
});
